import script from "./LinkEntityRolesList.vue?vue&type=script&setup=true&lang=js"
export * from "./LinkEntityRolesList.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__